import styled, { keyframes } from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const popIn = keyframes`
  from { opacity: 0; transform: translateY(14px) scale(0.96); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

const starPop = keyframes`
  0% { transform: scale(0.4) rotate(-25deg); opacity: 0; }
  65% { transform: scale(1.12) rotate(6deg); opacity: 1; }
  100% { transform: scale(1) rotate(0); }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(30, 27, 58, 0.5);
  backdrop-filter: blur(3px);
  animation: ${fadeIn} 0.2s ease-out;
`;

export const Modal = styled.div`
  width: 100%;
  max-width: 420px;
  border-radius: ${radius.xl};
  overflow: hidden;
  background: ${colors.surface};
  box-shadow: ${shadow.raised};
  animation: ${popIn} 0.3s ease-out;
`;

export const Hero = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 24px 26px;
  text-align: center;
  color: #FFFFFF;
  background:
    radial-gradient(90% 120% at 50% 0%, rgba(244, 182, 63, 0.45) 0%, rgba(244, 182, 63, 0) 55%),
    linear-gradient(160deg, ${colors.brandDark} 0%, ${colors.brandDeep} 70%, ${colors.brand} 100%);
`;

export const HeroStar = styled.div`
  animation: ${starPop} 0.7s ease-out;
  filter: drop-shadow(0 6px 16px rgba(244, 182, 63, 0.55));
`;

export const HeroLabel = styled.span`
  margin-top: 4px;
  padding: 4px 10px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.16);
`;

export const Title = styled.h2`
  font-family: ${font.text};
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
`;

export const Gift = styled.p`
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: ${font.text};
  font-size: 15px;
  font-weight: 600;
  opacity: 0.95;

  b {
    font-weight: 800;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 22px 24px 16px;
`;

export const Point = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: ${font.text};
  font-size: 15px;
  font-weight: 600;
  color: ${colors.ink};
`;

export const PointIcon = styled.span`
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: ${radius.sm};
  color: ${colors.brandDeep};
  background: ${colors.brandSoft};
`;

export const Primary = styled.button`
  margin-top: 8px;
  padding: 13px 20px;
  border-radius: ${radius.md};
  font-family: ${font.text};
  font-size: 16px;
  font-weight: 800;
  color: #FFFFFF;
  background: ${colors.brand};
  box-shadow: ${shadow.button(colors.brandDeep)};
  cursor: pointer;
  transition: transform 0.08s ease, box-shadow 0.08s ease;

  &:active {
    transform: translateY(3px);
    box-shadow: ${shadow.button("transparent")};
  }
`;

export const Secondary = styled.button`
  padding: 8px;
  font-family: ${font.text};
  font-size: 15px;
  font-weight: 700;
  color: ${colors.muted};
  background: none;
  cursor: pointer;
`;
